import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";

import {
  getImagesLoading,
  getImagesActionDispatcher,
  getImagesErrorDispatcher,
  GET_IMAGES_ACTION_REQUESTED,
} from "./Action";

const getImagesSerivce = async (searchKeyword) => {
  const result = await axios.get(
    `https://unsplash.vannizhang.com/getImages?tag=${searchKeyword}`
  );
  return result;
};

function* getImagesSaga({ searchKeyword }) {
  try {
    yield put(getImagesLoading(true));
    const success = yield call(getImagesSerivce, searchKeyword);
    yield put(getImagesActionDispatcher(success.data.length ? success.data : [] ));
    yield put(getImagesErrorDispatcher({}));
    yield put(getImagesLoading(false));
  } catch (e) {
    yield put(getImagesActionDispatcher([]));
    yield put(getImagesErrorDispatcher(e.response.data));
    yield put(getImagesLoading(false));
  }
}

function* getImagesWatcher() {
  yield takeEvery(GET_IMAGES_ACTION_REQUESTED, getImagesSaga);
}
export default getImagesWatcher;
